export class Contact {
  constructor(
    public id?: number,
    public companyName?: string,
    public firstname?: string,
    public lastname?: string,
    public email?: string,
    public phone?: string,
    public phone2?: string,
    public address?: string,
    public address2?: string,
    public city?: string,
    public state?: string,
    public zipCode?: string,
    public userName?: string,
    public optionalField1?: string,
    public optionalField2?: string,
    public optionalField3?: string,
    public optionalField4?: string,
    public optionalField5?: string,
    public name?: string,
    public country?: string
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/contact.ts